import instance from '../index';
const RESOURCE_SUBSCRIPTION = 'stripe';
const RESOURCE_SUBSCRIPTION_PLAN = 'package-plans';

export const SubscriptionApi = {
  /**
   * Get the list of available subscription plans
   * @returns {Promise<Object>} List of subscription plans
   */
  getSubscription() {
    return instance.get(`/${RESOURCE_SUBSCRIPTION_PLAN}/list`);
  },

  /**
   * Create a new subscription plan
   * @param {Object} data - The data for the new subscription plan
   * @returns {Promise<Object>} The created subscription plan
   */
  createSubcriptionplan(data) {
    return instance.post(`/${RESOURCE_SUBSCRIPTION}/create-subscription-plan`, data);
  },

  /**
   * Pay for a subscription plan
   * @param {string} planId - The ID of the plan to pay for
   * @returns {Promise<Object>} The payment response
   */
  payForSubscriptionPlan(planId) {
    return instance.post(`/${RESOURCE_SUBSCRIPTION}/subscription-plan/pay`, {
      plan_id: planId
    });
  },

  /**
   * Cancel a subscription plan
   * @returns {Promise<Object>} The cancellation response
   */
  cancelSubscriptionPlan() {
    return instance.post(`/${RESOURCE_SUBSCRIPTION}/subscription-plan/cancel`);
  },

  /**
   * Confirm a subscription payment
   * @returns {Promise<Object>} The confirmation response
   */
  confirmSubscriptionPayment(paymentIntentId) {
    return instance.post(`/${RESOURCE_SUBSCRIPTION}/subscription-plan/confirm`, {
      payment_intent_id: paymentIntentId
    });
  },

  /**
   * Request information about enterprise plan (sends email to admin)
   * @returns {Promise<Object>} The response indicating if the request was successful
   */
  requestEnterpriseContact() {
    return instance.get(`/${RESOURCE_SUBSCRIPTION_PLAN}/custom`);
  }
};
